import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import ActionButton from '../ActionButton'
import SectionTitle from '../FormElements/SectionTitle'
import CheckboxGroup from '../FormElements/CheckboxGroup'
import Slider from '../FormElements/Slider'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const FilterTitle = styled.span`
  ${({ theme }) => theme.textStyles.text_bold_24}
  margin: 0 auto 3rem auto;
  transform: translateX(2rem);

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.text_bold_32};
  }
`

export const FiltersPanel = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
`

export const HeroPanel = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const Checkbox = styled(CheckboxGroup)``
export const Title = styled(SectionTitle)``
export const SliderPicker = styled(Slider)``

export const InnerPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 81.5rem;
  margin: 0 auto;
  padding: 0 2rem;

  ${Title},
  ${Checkbox},
  ${SliderPicker} {
    margin-bottom: 3rem;
  }

  @media ${mq(sizes.tablet)} {
    ${Checkbox},
    ${SliderPicker} {
      margin-bottom: 5.5rem;
    }
  }
`

export const CloseCross = styled(ActionButton)``

export const FilterButton = styled(ActionButton)``

export const ApplyButton = styled(ActionButton)`
  align-items: center;
`
